import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
 
import { map } from 'rxjs/operators';
import { AuthTokenService } from '../../services/auth-token.service';
 

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private authTokenService: AuthTokenService,
 
  ) { }

  canActivate() :boolean {
    let token = this.authTokenService.getValueLocalstorage();
    //console.log(token);

    if (token) {
     return true 
    }else {
      this.router.navigate(['/auth/login'])
      return false;
    }
   
  }
}
